import request from "@/utils/request";

export function postFeedback(data) {
  return request({
    url: `/feedback/export/`,
    method: `post`,
    data,
  });
}
